import { INTRO_LIKERT_QUESTION, INTRO_SCENARIO } from "../content/intro-examples";
import { bloomScale } from "../lib/questions";

/** Alleen de vraagkaart — zelfde markup als QuestionStepShell + QuestionStepSlider. */
export function LikertIntroExampleCard() {
  return (
    <div className="bloom-question__card">
      <p className="bloom-question__text">{INTRO_LIKERT_QUESTION}</p>
      <div className="bloom-row" role="group" aria-label="Antwoordopties">
        {bloomScale.labels.map((label, index) => (
          <button key={index} type="button" className="bloom-row__item" tabIndex={-1}>
            {label}
          </button>
        ))}
      </div>
    </div>
  );
}

/** Alleen de vraagkaart — zelfde markup als QuestionStepShell + QuestionStepScenario. */
export function ScenarioIntroExampleCard() {
  return (
    <div className="bloom-question__card">
      <div className="bloom-scenario-block">
        <p className="bloom-scenario__label">Situatie</p>
        <p className="bloom-scenario__situation">{INTRO_SCENARIO.situation}</p>
      </div>
      <p className="bloom-question__text bloom-scenario__prompt">{INTRO_SCENARIO.prompt}</p>
      <div className="bloom-scenario" role="group" aria-label="Antwoordopties">
        {INTRO_SCENARIO.options.map((text, index) => (
          <button key={index} type="button" className="bloom-scenario__option" tabIndex={-1}>
            {text}
          </button>
        ))}
      </div>
    </div>
  );
}
